import React from 'react';
import Column from '../../column';
import Employee from './employee';

const EmployeeBlock = ({
  className,
  columnWidth,
  align,
  justify,
  order,
  offset,
  card,
  employee,
}) => (
  <Column
    className={className}
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    card={card}
    order={order}
    offset={offset}
  >
    <Employee {...employee} />
  </Column>
);

export default EmployeeBlock;
